import { type SuccessReadUserOrdersV2 } from '@redteclab/api/clients/bully'

import { orderStatusAccessorEnrichSingleOrderStatus } from './orderStatusAccessorEnrichSingleOrderStatus'

export const orderStatusAccessorEnrichMultipleOrdersStatus = (
  ordersResponse: SuccessReadUserOrdersV2,
): void => {
  const { orders } = ordersResponse
  if (!orders) {
    return
  }

  for (const order of orders) {
    if (!order.subOrders) {
      return
    }
    orderStatusAccessorEnrichSingleOrderStatus(order.subOrders)
  }
}
